import React from 'react';
import KomenIcon from '../../images/projectIcons/komen.png';

const Komen = (props) => (
  <img src={KomenIcon} alt="komen-logo" style={{ width: '64px', height: '64px', backgroundColor: 'transparent' }} {...props} />
);

export default Komen;
